import styles from "../../styles/components/blogs/BlogSkeletonLoader.module.css"

/**
 * Skeleton loader for blog cards during loading state
 * @param {number} count - Number of skeleton cards to show
 */
export default function BlogSkeletonLoader({ count = 9 }) {
  return (
    <div className={styles.skeletonGrid}>
      {Array.from({ length: count }, (_, index) => (
        <div key={index} className={styles.skeletonCard}>
          <div className={styles.skeletonImage}></div>
          <div className={styles.skeletonContent}>
            <div className={styles.skeletonTitle}></div>
            <div className={styles.skeletonDescription}></div>
            <div className={styles.skeletonDescription}></div>
            <div className={styles.skeletonMeta}>
              <div className={styles.skeletonDate}></div>
              <div className={styles.skeletonCategory}></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
